/** Kelp LRTOracle — 1e18-scaled ETH-per-rsETH. */
export const KelpLrtOracleAbi = [
  {
    name: 'rsETHPrice',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
